"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../../utilities/props.js";
import { onNextFrame } from "../../../utilities/animation.js";
import useIsomorphicLayoutEffect from "../../../hooks/useIsomorphicLayoutEffect.js";
import s from "./Expandable.module.css";
const Expandable = (props) => {
    const { children, active, attributes } = props;
    const rootRef = React.useRef(null);
    const mountedRef = React.useRef(false);
    const [animatedHeight, setAnimatedHeight] = React.useState(active ? "auto" : null);
    const contentClassNames = classNames(s.root, 
    // eslint-disable-next-line react-hooks/refs
    mountedRef.current && animatedHeight !== "auto" && s["--animated"]);
    const handleTransitionEnd = (e) => {
        if (e.propertyName !== "height")
            return;
        setAnimatedHeight(active ? "auto" : null);
    };
    // Avoid animations happening if component is active by default
    // onNextFrame lets us wait for the component to render first
    React.useEffect(() => {
        onNextFrame(() => {
            mountedRef.current = true;
        });
    }, []);
    useIsomorphicLayoutEffect(() => {
        const rootEl = rootRef.current;
        if (!rootEl || !mountedRef.current)
            return;
        if (active) {
            rootEl.style.height = "auto";
            requestAnimationFrame(() => {
                const targetHeight = rootEl.clientHeight;
                rootEl.style.height = "0";
                requestAnimationFrame(() => {
                    setAnimatedHeight(targetHeight);
                });
            });
        }
        else {
            rootEl.style.height = `${rootEl.clientHeight}px`;
            requestAnimationFrame(() => {
                setAnimatedHeight(0);
            });
        }
    }, [active]);
    return (_jsx("div", { ...attributes, className: contentClassNames, ref: rootRef, style: animatedHeight !== null
            ? { height: animatedHeight, overflow: animatedHeight === "auto" ? "visible" : undefined }
            : undefined, onTransitionEnd: handleTransitionEnd, role: "region", hidden: !active && animatedHeight === null, children: children }));
};
Expandable.displayName = "Expandable";
export default Expandable;
